import * as actionTypes from '../actionTypes/Whiteboard'
import { updateObject } from '../utility'

export const initialState = {
    isWhiteboardFullSize: false,
    prevWidth: null,
    whiteboardUrl: '',
    previousWhiteboard: false,
}

const setWhiteboardSize = (state, action) => {
    return updateObject(state, {
        isWhiteboardFullSize: action.isWhiteboardFullSize,
    })
}

const setWhiteboardUrl = (state, action) => {
    return updateObject(state, {
        whiteboardUrl: action.whiteboardUrl,
    })
}

const setPreviousWhiteboard = (state, action) => {
    return updateObject(state, {
        previousWhiteboard: action.previousWhiteboard,
    })
}

const Whiteboard = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_WHITEBOARD_SIZE:
            return setWhiteboardSize(state, action)
        case actionTypes.SET_WHITEBOARD_URL:
            return setWhiteboardUrl(state, action)
        case actionTypes.SET_PREVIOUS_WHITEBOARD:
            return setPreviousWhiteboard(state, action)
        default:
            return state
    }
}

export default Whiteboard
